<div class="navbar">
    <div>
        <img src="../../../assets/vectors/Help Desk Icon.svg" class="navbar-icon" alt="Help Desk Icon">
        <span class="v-rule navbar-sep-margin"></span>
        <span class="dashboard-span">Dashboard / </span>
        <span class="helpdesk-span">Help Desk</span>
    </div>

    <div class="username-div">
        <span class="username-div-span">{{ userName }}</span>
    </div>

    <div class="navbar-flex-div">
        <div class="navbar-flex-sub-div">
            <button class="logout-btn" (click)="openLogOutComponent()">
                <span class="logout-btn-span">
                    <img src="../../../assets/vectors/Profile Icon.svg" alt="Profile Icon">
                </span>
            </button>

            <div *ngIf="openLogoutPopup" class="log-out-popup">
                <div>
                    <button class="log-out-popup-btn" (click)="logout()">
                        <img src="../../../assets/vectors/material-symbols_logout.svg" alt="Logout"> Logout
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="header-form-container">
    <div class="header-form-sub-div-flex-container">
        <!-- role="search" makes this a landmark assistive tech can jump to. The
             input is labelled with aria-label because a placeholder is not a
             label: it disappears as soon as anything is typed. The icons are
             marked decorative (alt="") and each button carries its own name, so
             the button is announced once rather than as "image, button". -->
        <form role="search" (ngSubmit)="submitSearchForm()" class="search-box">
            <input type="text" name="searchBoxText" [(ngModel)]="searchBoxText" placeholder="Search..."
                aria-label="Search tickets" autocomplete="off">
            <button type="button" aria-label="Clear search" (click)="clearSearchForm()">
                <img src="../../../assets/vectors/Incorrect Icon.svg" alt="">
            </button>
            <span class="v-rule button-divider" aria-hidden="true"></span>
            <button type="submit" aria-label="Search">
                <img src="../../../assets/vectors/Icon.svg" alt="">
            </button>
        </form>
        <span class="v-rule line-sep-margin-2"></span>
        <div class="group-filter">
            <img class="group-filter-img-style" src="../../../assets/vectors/fluent-mdl2_away-status.svg" alt="Status">
            <ejs-dropdownlist class="dropdown" id='dropdown' [dataSource]='statusData' [popupWidth]="'auto'" placeholder="Status"
                [fields]="{text: 'text', value: 'value'}" (valueChange)="statusChange($event)"
                [valueTemplate]="customTemplate2" [value]="selectedStatus">
                <ng-template #customTemplate2 let-data>
                    <span class="group-filter-span-style">{{
                        data.text }}</span>
                </ng-template>
            </ejs-dropdownlist>
        </div>
    </div>
    <button class="create-ticket-btn" (click)="openTicketDetails()">
        <span class="create-ticket-btn-span">
            <img src="../../../assets/vectors/Group 1138.svg" alt="Create Ticket">
        </span>
        Create Ticket
    </button>
</div>

<div class="error-container">
    <p *ngIf="searchTextError" class="mandatory-field-and-error-msg">*Invalid input: Only letters,
        numbers, underscores, and spaces are allowed. Maximum length is 600 characters.</p>
</div>

<!-- Shared pager for both ticket grids. `sorted` picks the sorted grid's
     handlers; page, range and count are the same fields either way. -->
<ng-template #ticketsPager let-sorted="sorted">
    <div class="pagination-div">
        <div class="pager-controls">
            <button type="button" class="pager-btn" aria-label="First page"
                [disabled]="!prevBtn" (click)="sorted ? firstPageSort() : firstPage()">
                <img class="pager-icon-double" src="../../../assets/vectors/double-arrow-left.svg" alt="">
            </button>
            <button type="button" class="pager-btn" aria-label="Previous page"
                [disabled]="!prevBtn" (click)="sorted ? prevPageSort(prevBtn, filter, order) : prevPage(prevBtn, selectedStatus)">
                <img class="pager-icon" src="../../../assets/vectors/single-arrow-left.svg" alt="">
            </button>
            <span class="pager-current">{{ page }}</span>
            <button type="button" class="pager-btn" aria-label="Next page"
                [disabled]="!nextBtn" (click)="sorted ? nextPageSort(nextBtn, filter, order) : nextPage(nextBtn, selectedStatus)">
                <img class="pager-icon pager-icon-flip" src="../../../assets/vectors/single-arrow-left.svg" alt="">
            </button>
            <button type="button" class="pager-btn" aria-label="Last page"
                [disabled]="!nextBtn" (click)="sorted ? lastPageSort() : lastPage()">
                <img class="pager-icon-double pager-icon-flip" src="../../../assets/vectors/double-arrow-left.svg" alt="">
            </button>
        </div>

        <span class="pager-label">Page</span>
        <div class="pager-field">
            <input class="pager-page-input" type="number" min="1" [max]="totalPages"
                [value]="page" aria-label="Page number" (change)="sorted ? goToPageSort($event) : goToPage($event)">
        </div>
        <span class="pager-label">of {{ totalPages }}</span>

        <div class="pager-field pager-select-field">
            <select class="pager-select" aria-label="Items per page" (change)="sorted ? onPageSizeChangeSort($event) : onPageSizeChange($event)">
                <option [value]="5" [selected]="page_size == 5">5</option>
                <option [value]="10" [selected]="page_size == 10">10</option>
                <option [value]="25" [selected]="page_size == 25">25</option>
                <option [value]="50" [selected]="page_size == 50">50</option>
                <option [value]="70" [selected]="page_size == 70">70</option>
                <option [value]="100" [selected]="page_size == 100">100</option>
            </select>
            <img class="pager-chevron" src="../../../assets/vectors/chevron-down.svg" alt="">
        </div>
        <span class="pager-label">Items per page</span>

        <span class="pager-range">{{ rangeStart }} - {{ rangeEnd }} of {{ totalCountPerStatus }} items</span>
    </div>
</ng-template>

@if (!showSortGrid) {
<div class="grid-margin">
    <app-loader [loading]="isLoading" type="grid"></app-loader>
    <ng-container *ngIf="!isLoading">
        <ejs-grid [dataSource]="data" [allowPaging]="false" [allowSorting]="true" [filterSettings]="filterOptions">
            <e-columns>
                <ng-template #emptyRecordTemplate>
                    <div>
                        <span>No tickets found. Please adjust your filters or check back later.</span>
                    </div>
                </ng-template>
                <e-column field="ticket_id" headerText="Ticket ID" width="120" [allowSorting]="true">
                    <ng-template #headerTemplate>
                        <div class="ticket-id-header">
                            <span>Ticket ID</span>
                            <img src="../../../assets/vectors/Filter Icon.svg" alt="">
                        </div>
                    </ng-template>
                    <ng-template #template let-data>
                        <a class="grid-link text-decoration" (click)="getTicketDetails(data.ticket_id)">
                            # {{ data.ticket_id }}
                        </a>
                    </ng-template>
                </e-column>
                <e-column field="email_subject" headerText="Subject">
                    <ng-template #template let-data>
                        <a class="grid-link text-decoration-none" [title]="data.email_subject"
                            (click)="getTicketDetails(data.ticket_id)">
                            {{ data.email_subject }}
                        </a>
                    </ng-template>
                </e-column>
                <!-- Subject deliberately carries no width: it absorbs whatever the
                     fixed columns leave. Its floor is set in the stylesheet, on the
                     grid's table - a minWidth here does nothing, because Syncfusion
                     leaves this column's <col> empty under table-layout: fixed and it
                     simply takes what is left over, which can be nothing. -->
                <!-- Widths are measured, not guessed: the widest status is "Unassigned"
                     (88px in Poppins 15) and the widest date is a May one,
                     "28-May-2025, 22:58" (149px). A data cell spends 21px on padding
                     and a header cell 44px on its sort and filter icons, so these are
                     the worst case plus room to spare. Subject carries no width and
                     absorbs whatever is left. -->
                <e-column field="ticket_status" headerText="Status" width="135"></e-column>
                <e-column field="updated_at" headerText="Last Updated" width="200" [allowSorting]="true">
                    <ng-template #headerTemplate>
                        <div class="last-updated-header">
                            <span>Last Updated</span>
                            <img src="../../../assets/vectors/Filter Icon.svg" alt="">
                        </div>
                    </ng-template>
                </e-column>
                <e-column field="created_at" headerText="Created On" width="200"></e-column>
                <e-column field="created_by_name" headerText="Created By" width="180">
                    <ng-template #template let-data>
                        <span class="created_at_span" [title]="data.created_by_email || userEmail">
                            {{ data.created_by_name || userName }}
                        </span>
                    </ng-template>
                </e-column>
                <e-column field="team_lead" headerText="Agent" width="180"></e-column>
            </e-columns>
        </ejs-grid>
        <ng-container *ngTemplateOutlet="ticketsPager; context: { sorted: false }"></ng-container>
    </ng-container>
</div>
} @else {
<div class="grid-margin">
    <app-loader [loading]="isLoading" type="grid"></app-loader>
    <ng-container *ngIf="!isLoading">
        <ejs-grid [dataSource]="data" [allowPaging]="false" [allowSorting]="true" [filterSettings]="filterOptions">
            <e-columns>
                <ng-template #emptyRecordTemplate>
                    <div>
                        <span>No tickets found. Please adjust your filters or check back later.</span>
                    </div>
                </ng-template>
                <e-column field="ticket_id" headerText="Ticket ID" width="120" [allowSorting]="true">
                    <ng-template #headerTemplate>
                        <div class="ticker_id_header_2">
                            <span>Ticket ID</span>
                            <img src="../../../assets/vectors/Filter Icon.svg" alt="">
                        </div>
                    </ng-template>
                    <ng-template #template let-data>
                        <a class="ticker_id_content" (click)="getTicketDetails(data.ticket_id)">
                            # {{ data.ticket_id }}
                        </a>
                    </ng-template>
                </e-column>
                <e-column field="email_subject" headerText="Subject">
                    <ng-template #template let-data>
                        <a class="email_subject" [title]="data.email_subject"
                            (click)="getTicketDetails(data.ticket_id)">
                            {{ data.email_subject }}
                        </a>
                    </ng-template>
                </e-column>
                <e-column field="ticket_status" headerText="Status" width="135"></e-column>
                <e-column field="updated_at" headerText="Last Updated" width="200" [allowSorting]="true">
                    <ng-template #headerTemplate>
                        <div class="updated_at_content">
                            <span>Last Updated</span>
                            <img src="../../../assets/vectors/Filter Icon.svg" alt="">
                        </div>
                    </ng-template>
                </e-column>
                <e-column field="created_at" headerText="Created On" width="200"></e-column>
                <e-column field="created_by_name" headerText="Created By" width="180">
                    <ng-template #template let-data>
                        <span class="created_at_span" [title]="data.created_by_email || userEmail">
                            {{ data.created_by_name || userName }}
                        </span>
                    </ng-template>
                </e-column>
                <e-column field="team_lead" headerText="Agent" width="180"></e-column>
            </e-columns>
        </ejs-grid>
        <ng-container *ngTemplateOutlet="ticketsPager; context: { sorted: true }"></ng-container>
    </ng-container>
</div>
}

<div class="popup-overlay">
    <ejs-dialog id="syncfusion-dialog" [visible]="addNewTicket" [showCloseIcon]="true" [width]="'1086px'"
        [height]="'825px'" [isModal]="true" (beforeClose)="closePopup()" cssClass="create-ticket-dialog">
        <ng-template #header>
            <div title="Create Ticket"> Create Ticket </div>
        </ng-template>
        <ng-template #content>
            <form class="form-div" #createTicketForm="ngForm" (ngSubmit)="submitTicketForm()">
                <div *ngIf="isSubmitting" class="loader-overlay">
                    <div class="spinner"></div>
                </div>
                <div class="input-group">
                    <label class="form-label" for="ticketSubject">
                        <span class="mandatory-field-and-error-msg">*</span>
                        Subject
                    </label>
                    <div class="subject-field">
                        <ejs-textbox class="textarea" id="ticketSubject" placeholder="Ticket subject"
                            floatLabelType="Never" [width]="'100%'" [(ngModel)]="ticketSubject" name="ticketSubject"
                            [htmlAttributes]="{ autocomplete: 'off' }">
                        </ejs-textbox>
                        <span class="subject-char-count" aria-hidden="true">
                            <span class="subject-char-count-used">{{ ticketSubject.length }}</span>/100
                        </span>
                    </div>
                    <p *ngIf="ticketSubject.length >= 100" class="mandatory-field-and-error-msg">
                        *Ticket subject must be less than 100 characters</p>
                    <p *ngIf="ticketSubjectErrorMessage" class="mandatory-field-and-error-msg">*{{
                        ticketSubjectErrorMessage }}</p>

                </div>
                <div class="input-group">
                    <label class="form-label" for="issueType">Issue Type</label>
                    <ejs-dropdownlist class="dropdown-custom" id="issueType" [dataSource]="issueData" placeholder="Issue type"
                        [fields]="{ text: 'text', value: 'value' }" [(ngModel)]="ticketIssue" name="tickerIssue">
                    </ejs-dropdownlist>
                </div>
                <div class="input-group">
                    <label class="form-label" for="participants">Add Participants</label>
                    <ejs-textbox class="textarea" id="participants" floatLabelType="Never" [width]="'100%'" [multiline]="true"
                        [(ngModel)]="participants" name="participants"
                        placeholder="Add emails of the participants separated by semicolon">
                    </ejs-textbox>
                    <p *ngIf="participantsErrorMessage" class="mandatory-field-and-error-msg">*{{
                        participantsErrorMessage }}</p>
                </div>
                <div class="input-group margin-bottom-20px">
                    <label class="form-label" for="defaultRTE">
                        <span class="mandatory-field-and-error-msg">*</span>
                        Ticket Description
                    </label>
                    <ejs-richtexteditor class="rte-ctm" #rte placeholder="Add a message..." [(ngModel)]="ticketMessage"
                        [toolbarSettings]="tools" [height]="'158px'" name="ticketMessage"
                        (imageSelected)="onImageSelected($event)">
                        >
                        <ng-template #valueTemplate></ng-template>
                    </ejs-richtexteditor>

                    <p *ngIf="ticketMessageErrorMessage" class="mandatory-field-and-error-msg">*{{
                        ticketMessageErrorMessage }}</p>
                </div>
                <div class="file-input margin-bottom-20px">
                    <button type="button" class="upload-files" (click)="triggerFileInput()">
                        <img src="../../../assets/vectors/upload 2.svg" alt="Upload"> Upload
                        Files
                    </button>
                    <input type="file" #fileInput (change)="handleFileSelect($event)" multiple>
                    <p>
                        Upload a screenshot, recording, or any other file that describes your problem.
                    </p>
                </div>
                @if (uploadedFilesArray.length === 0) {
                <p class="no-attachments">
                    No attachments added yet.
                </p>
                }
                @else if (uploadedFilesArray.length > 0) {
                <ul class="file-input-list">
                    @for (file of uploadedFilesArray; track $index) {
                    @if (file.type === 'image/png') {
                    <div class="file-chip">
                        <img src="../../../assets/vectors/PNG Icon.svg" alt="PNG File">
                        {{ file.name }}
                        <button><img src="../../../assets/vectors/Group 1210.svg"
                                (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                    </div>
                    } @else if (file.type === 'application/pdf') {
                    <div class="file-chip">
                        <img src="../../../assets/vectors/Pdf icon.svg" alt="PDF File">
                        {{ file.name }}
                        <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                    </div>
                    } @else if (file.type === 'text/plain') {
                    <div class="file-chip">
                        <img src="../../../assets/vectors/TXT Icon.svg" alt="TXT File">
                        {{ file.name }}
                        <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                    </div>
                    } @else if (file.type === 'video/mp4') {
                    <div class="file-chip">
                        <img src="../../../assets/vectors/Screen Recording Icon.svg" alt="MP4 File">
                        {{ file.name }}
                        <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                    </div>
                    } @else if (file.type === 'application/zip') {
                    <div class="file-chip">
                        <img src="../../../assets/vectors/ZIP icon.svg" alt="ZIP File">
                        {{ file.name }}
                        <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                    </div>
                    } @else {
                    <div class="file-chip">
                        {{ file.name }}
                        <button type="button"><img src="../../../assets/vectors/Group 1210.svg"
                                (click)="removeFileFromUploadedArray(file)" alt="Remove File"></button>
                    </div>
                    }
                    }
                </ul>
                }
                <p *ngIf="fileUploadErrorMessage" class="mandatory-field-and-error-msg">*{{
                    fileUploadErrorMessage }}</p>

                <div class="submit-btn-div">
                    <button class="submit-btn" type="submit">Submit</button>
                </div>
            </form>
        </ng-template>
    </ejs-dialog>
</div>

<div *ngIf="ticketNotAssigned" class="error-popup-overlay">
    <div class="error-popup-content">
        The team has not taken any action on this ticket yet but will address it as soon as possible.
        Since this ticket was created via email, you will not be able to access it until the team begins processing it.
        <button type="button" class="error-popup-close" (click)="ticketNotAssigned = false">&times;</button>
    </div>
</div>

<div *ngIf="rateLimitingError" class="error-popup-overlay">
    <div class="error-popup-content">
        Too many requests. Please wait a while.
        <button type="button" class="error-popup-close" (click)="rateLimitingError = false">&times;</button>
    </div>
</div>

<div *ngIf="noCustomerFound" class="error-popup-overlay">
    <div class="error-popup-content">
      {{ errorMessage }}
        <button type="button" class="error-popup-close" (click)="noCustomerFound = false">&times;</button>
    </div>
</div>

<!-- <div *ngIf="noCustomerFound" class="error-popup-overlay">
    <div class="error-popup-content">
       {{ errorMessage }}
        <button type="button" class="error-popup-close" (click)="noCustomerFound = false">&times;</button>
    </div>
</div> -->